module.exports = __webpack_public_path__ + "img/dummy9.8fbf673.jpg";